import { render, staticRenderFns } from "./AlumniMemberView.vue?vue&type=template&id=61287999"
import script from "./AlumniMemberView.vue?vue&type=script&lang=js"
export * from "./AlumniMemberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports